/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography, Grid } from "@mui/material";

import Footer from "./footer";
import SoftSelect from "components/SoftSelect";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import Dropdown from "./dropdown";
const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  background: "#ddeff3",
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style, fontSize: "14px " }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th
      {...rest}
      style={{ ...thTdStyle, ...style, fontWeight: row.bold ? "bold" : 400, fontSize: "14px" }}
    >
      {children}
    </th>
  );
};
const defaultOption = [
  {
    value: "title",
    label: "title",
    disabled: true,
  },
];

const billIDOption = [
  {
    value: "01GTKT",
    label: "01GTKT",
    disabled: false,
  },
  {
    value: "02GTTT",
    label: "02GTTT",
    disabled: false,
  },
  {
    value: "07KPTQ",
    label: "07KPTQ",
    disabled: false,
  },
  {
    value: "03XKNP",
    label: "03XKNP",
    disabled: false,
  },
  {
    value: "04HGDL",
    label: "04HGDL",
    disabled: false,
  },
  {
    value: "01BHDT",
    label: "01BHDT",
    disabled: false,
  },
  {
    value: "01/",
    label: "01/",
    disabled: false,
  },
  {
    value: "02/",
    label: "02/",
    disabled: false,
  },
  {
    value: "TT120",
    label: "TT120",
    disabled: false,
  },
  {
    value: "01TEDB",
    label: "01TEDB",
    disabled: false,
  },
  {
    value: "01VEDB",
    label: "01VEDB",
    disabled: false,
  },
  {
    value: "01THDB",
    label: "01THDB",
    disabled: false,
  },
  {
    value: "02TEDB",
    label: "02TEDB",
    disabled: false,
  },
  {
    value: "02VEDB",
    label: "02TEDB",
    disabled: false,
  },
  {
    value: "02THDB",
    label: "02TEDB",
    disabled: false,
  },
];

const formBillOption = [
  {
    value: "T",
    label: "T",
    disabled: false,
  },
  {
    value: "P",
    label: "P",
    disabled: false,
  },
  {
    value: "E",
    label: "E",
    disabled: false,
  },
];

const dataTable = [
  {
    onlyTitle: true,
    bold: true,
    id: {
      value: 1,
      bg: true,
    },
    billId: {
      type: "select",
      value: null,
      bg: false,
      option: billIDOption,
    },
    billName: {
      type: "input",
      value: null,
      bg: false,
    },
    denominatorSymbolBill: {
      type: "input",
      value: null,
      bg: false,
    },
    formBill: {
      type: "select",
      value: null,
      bg: false,
      option: formBillOption,
    },

    beginningQuantity: {
      type: "input",
      value: 0,
      bg: false,
    },

    quantityPurchased: {
      type: "input",
      value: 0,
      bg: false,
    },
    use: {
      type: "input",
      value: 0,
      bg: false,
    },
    delete: {
      type: "input",
      value: 0,
      bg: false,
    },
    lost: {
      type: "input",
      value: 0,
      bg: false,
    },
    cancel: {
      type: "input",
      value: 0,
      bg: false,
    },
    sum: {
      type: "input",
      value: 0,
      bg: true,
    },

    last: {
      type: "input",
      value: 0,
      bg: true,
    },
    note: {
      type: "input",
      value: null,
      bg: false,
    },
  },
];
export default function BillBc26Table({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const getMaxIdValue = () => {
    return Math.max(...data.map((item) => item.id.value), 0);
  };

  const addNewRow = () => {
    const newIdValue = getMaxIdValue() + 1;
    const newRow = {
      onlyTitle: true,
      bold: true,
      id: {
        value: newIdValue,
        bg: true,
      },
      billId: {
        type: "select",
        value: null,
        bg: false,
        option: billIDOption,
      },
      billName: {
        type: "input",
        value: null,
        bg: false,
      },
      denominatorSymbolBill: {
        type: "input",
        value: null,
        bg: false,
      },
      formBill: {
        type: "select",
        value: null,
        bg: false,
        option: formBillOption,
      },

      beginningQuantity: {
        type: "input",
        value: 0,
        bg: false,
      },

      quantityPurchased: {
        type: "input",
        value: 0,
        bg: false,
      },
      use: {
        type: "input",
        value: 0,
        bg: false,
      },
      delete: {
        type: "input",
        value: 0,
        bg: false,
      },
      lost: {
        type: "input",
        value: 0,
        bg: false,
      },
      cancel: {
        type: "input",
        value: 0,
        bg: false,
      },
      sum: {
        type: "input",
        value: 0,
        bg: true,
      },

      last: {
        type: "input",
        value: 0,
        bg: true,
      },
      note: {
        type: "input",
        value: null,
        bg: false,
      },
    };
    setData((prev) => [...prev, newRow]);
  };

  const removeRow = () => {
    if (data.length !== 1) {
      data.pop();
      const newRow = data;
      setData([...newRow]);
    }
  };

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id.value === id) {
          return { ...item, [name]: { ...item[name], value } };
        }
        return item;
      })
    );
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Grid item xs={12} style={{ paddingTop: 0 }}>
        <Typography component="label" variant="caption" fontWeight="bold" fontSize={14}>
          3 Các loại hóa đơn khác
        </Typography>
      </Grid>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                STT
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Mã hóa đơn
              </Th>
              <Th style={{ textAlign: "center", width: "150px" }} rowSpan="2">
                Tên loại hóa đơn
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Ký hiệu mẫu hóa đơn
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Hình thức hóa đơn
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Số lượng tồn đầu kỳ
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Số lượng mua, phát hành trong kỳ
              </Th>
              <Th style={{ textAlign: "center" }} colSpan="5">
                Sử dụng trong kỳ
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Tồn cuối kỳ
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Ghi chú
              </Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center" }}>Sử dụng</Th>
              <Th style={{ textAlign: "center" }}>Xóa bỏ</Th>
              <Th style={{ textAlign: "center" }}>Mất</Th>

              <Th style={{ textAlign: "center" }}>Hủy</Th>
              <Th style={{ textAlign: "center" }}>Cộng</Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center" }}>(1)</Th>
              <Th style={{ textAlign: "center" }}></Th>
              <Th style={{ textAlign: "center" }}>(2)</Th>
              <Th style={{ textAlign: "center" }}>(3)</Th>
              <Th style={{ textAlign: "center" }}>(4)</Th>
              <Th style={{ textAlign: "center" }}>(5)</Th>
              <Th style={{ textAlign: "center" }}>(6)</Th>
              <Th style={{ textAlign: "center" }}>(7)</Th>
              <Th style={{ textAlign: "center" }}>(8)</Th>
              <Th style={{ textAlign: "center" }}>(9)</Th>
              <Th style={{ textAlign: "center" }}>(10)</Th>
              <Th style={{ textAlign: "center" }}>(11)</Th>
              <Th style={{ textAlign: "center" }}>(12)</Th>
              <Th style={{ textAlign: "center" }}>(13)</Th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((row, index) => (
                <tr key={row.id.value + index}>
                  <Td
                    row={""}
                    style={{
                      textAlign: "center",
                      background: "transparent",
                    }}
                  >
                    {row?.id?.value}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "left",
                      background: !row.billId.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.billId.bg ? (
                      row.billId.value
                    ) : row.billId?.type === "select" ? (
                      <SelectTable
                        name="billId"
                        id={row.id.value}
                        option={row.billId.option ? row.billId.option : defaultOption}
                        onSelect={handleChange}
                      />
                    ) : (
                      <InputTable
                        id={row.id.value}
                        name="billId"
                        value={row.billId.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.billName.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.billName?.type !== "input" ? (
                      row.billName.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="billName"
                        value={row.billName.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.denominatorSymbolBill.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.denominatorSymbolBill?.type !== "input" ? (
                      row.denominatorSymbolBill.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="denominatorSymbolBill"
                        value={row.denominatorSymbolBill.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "left",
                      background: !row.formBill.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.formBill.bg ? (
                      row.formBill.value
                    ) : row.formBill?.type === "select" ? (
                      <SelectTable
                        name="formBill"
                        id={row.id.value}
                        option={row.formBill.option ? row.formBill.option : defaultOption}
                        onSelect={handleChange}
                      />
                    ) : (
                      <InputTable
                        id={row.id.value}
                        name="formBill"
                        value={row.formBill.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.beginningQuantity.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.beginningQuantity?.type !== "input" ? (
                      row.beginningQuantity.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="beginningQuantity"
                        value={row.beginningQuantity.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.quantityPurchased.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.quantityPurchased?.type !== "input" ? (
                      row.quantityPurchased.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="quantityPurchased"
                        value={row.quantityPurchased.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.use.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.use?.type !== "input" ? (
                      row.use.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="use"
                        value={row.use.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.delete.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.delete?.type !== "input" ? (
                      row.delete.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="delete"
                        value={row.delete.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.lost.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.lost?.type !== "input" ? (
                      row.lost.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="lost"
                        value={row.lost.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.cancel.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.cancel?.type !== "input" ? (
                      row.cancel.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="cancel"
                        value={row.cancel.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.sum.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.sum?.type !== "input" ? (
                      row.sum.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="sum"
                        value={row.sum.value}
                        onChange={handleChange}
                        disabled={true}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.last.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.last?.type !== "input" ? (
                      row.last.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="last"
                        value={row.last.value}
                        onChange={handleChange}
                        disabled={true}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.note.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.note?.type !== "input" ? (
                      row.note.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="note"
                        value={row.note.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                </tr>
              ))}
            <tr>
              <Td
                colspan="4"
                row={{ bold: true }}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              >
                Tổng cộng:
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                0
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                0
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                0
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                0
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                0
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                0
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                0
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >0</Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
            </tr>
          </tbody>
        </table>
        <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
          <SoftButton variant="gradient" color="dark" onClick={addNewRow}>
            Thêm dòng
          </SoftButton>
          <SoftButton variant="gradient" color="light" onClick={removeRow}>
            Xóa dòng
          </SoftButton>
        </SoftBox>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, type, fields, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      style={{
        textAlign: type === "number" ? "right" : "left",
        fontSize: 16,
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
      }}
      onChange={handleChange}
      type={fields}
      {...rest}
    />
  );
}

function SelectTable(props) {
  const { id, onSelect, type, option, name, style, ...rest } = props;
  const [newValue, setNewValue] = useState();
  useEffect(() => {
    if (typeof onSelect === "function") {
      onSelect({ id, value: newValue !== "" ? newValue : "", name });
    }
  }, [newValue]);
  return (
    <div style={style}>
      <Dropdown option={option} id={id} newValue={newValue} setNewValue={setNewValue} />
    </div>
  );
}
